
    import { mapActions, mapMutations, mapState } from 'vuex';
    import TabBar from '@/components/Utils/TabBar';
    import Tab from '@/components/Utils/Tab';
    import SearchDropdownAttributes from '@/components/Search/Filters/SearchDropdownAttributes';

    export default {
        name: 'SearchPayRange',

        components: {
            TabBar,
            Tab,
            SearchDropdownAttributes,
        },

        data() {
            return {
                salaryRangeError: false,
                defaultMaxSalary: {
                    value: '99999999.00',
                    label: '$250000.00+',
                },
                defaultMinSalary: {
                    value: '0.00',
                    label: '$0',
                },
                selectedPayTypeId: 1,
                refreshTabBar: 0,
            };
        },

        computed: {
            ...mapState({
                $_search: state => state.search,
                $_payTypes: state => state.payType.payTypes,
            }),
        },

        watch: {
            '$_search.searchPayload.search_filters': {
                handler(n) {
                    this.initPayRange();
                    this.refreshTabBar++;
                },
                deep: true,
            },
        },

        created() {
            this.initPayRange();
        },

        methods: {
            ...mapMutations('search', {
                $_SET_SEARCH_FILTERS: 'SET_SEARCH_FILTERS',
                $_SET: 'SET',
            }),

            ...mapActions('payType', {
                $_getSalarySearchFilter: 'getSalarySearchFilter',
            }),

            initPayRange() {
                if (this.$_search.searchPayload.search_filters.display_pay_type) {
                    this.selectedPayTypeId = parseInt(this.$_search.searchPayload.search_filters.display_pay_type);
                }
                this.getSalaries();
            },

            async onPayTypeSelect(index, selectedTab) {
                const payTypeId = selectedTab.data.id;
                this.selectedPayTypeId = parseInt(payTypeId);
                await this.getSalaries();
            },

            async getSalaries() {
                const payTypeId = this.selectedPayTypeId;
                const payTypeCode = this.$_payTypes[parseInt(payTypeId)]?.code || 'annual_salary';
                const salaries = await this.$_getSalarySearchFilter(payTypeCode);
                this.$_SET({
                    key: 'salaries',
                    value: salaries,
                });
            },

            validateSalary() {
                const searchFilters = this.$_search.searchPayload.search_filters;
                const minSalary = searchFilters.pay_min;
                const maxSalary = searchFilters.pay_max;

                if (minSalary && maxSalary) {
                    if (parseInt(maxSalary.value) < parseInt(minSalary.value)) {
                        this.salaryRangeError = true;
                        this.$_SET_SEARCH_FILTERS({
                            key: 'pay_max',
                            value: '',
                        });
                    } else {
                        this.salaryRangeError = false;
                        this.$emit('validated');
                    }
                }

                this.$_SET_SEARCH_FILTERS({
                    key: 'display_pay_type',
                    value: this.selectedPayTypeId,
                    preventSearch: true,
                });
            },
        },
    };
